"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _polished = require("polished");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _eyeClosed = _interopRequireDefault(require("../../../../public/images/icons/eye-closed.svg"));

var _eyeOpen = _interopRequireDefault(require("../../../../public/images/icons/eye-open.svg"));

var _ButtonNorma = require("../../../components/ButtonNorma");

var _Input = require("../../../components/Ui/Form/Input");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

var PasswordContainer = _styledComponents["default"].div.withConfig({
  displayName: "InputPassword__PasswordContainer",
  componentId: "lm6xui-0"
})(["position:relative;"]);

var ButtonPasswordReveal = (0, _styledComponents["default"])(_ButtonNorma.ButtonIcon).withConfig({
  displayName: "InputPassword__ButtonPasswordReveal",
  componentId: "lm6xui-1"
})(["top:-5px;right:0;&&{position:absolute;color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return (0, _polished.lighten)(0.25, theme.colors.irisBlue);
});

var InputPassword = function InputPassword(_ref2) {
  var value = _ref2.value,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["value"]);

  var _useState = (0, _react.useState)(false),
      isRevealingPassword = _useState[0],
      setRevealPassword = _useState[1];

  function handleRevealPassword() {
    setRevealPassword(!isRevealingPassword);
  }

  var displayRevealButton = (value || '').length > 0;
  return __jsx(PasswordContainer, null, __jsx(_Input.Input, (0, _extends2["default"])({
    value: value
  }, props, {
    type: isRevealingPassword ? 'text' : 'password'
  })), displayRevealButton && __jsx(ButtonPasswordReveal, {
    Icon: isRevealingPassword ? _eyeClosed["default"] : _eyeOpen["default"],
    variant: "ghost",
    tone: "subtle",
    label: "Reveal password",
    "aria-pressed": isRevealingPassword,
    title: isRevealingPassword ? 'Hide password' : 'Reveal password',
    onClick: handleRevealPassword
  }));
};

var _default = InputPassword;
exports["default"] = _default;